import React, { Component } from 'react';
import { Card, Table } from 'react-bootstrap'
import { mobileIcon } from '../../img/font_awesome/font_awesome';
import translations from "../../config/translation/home_translations.json"
import { connect } from "react-redux";

const mapStateToProps = state => {
    return {
        language: state.currentUserReducer.language ? state.currentUserReducer.language : 'ENGLISH',
    };
}

class ContactTenants extends Component {
    render() {

        let transactionTotalsTable = <></>;
        if (this.props.transactionTotals) {
            transactionTotalsTable =
                <Table size='sm'>
                    <tbody>
                        {
                            this.props.transactionTotals.rows.map((row, index) => {
                                return <tr key={index}>
                                    {
                                        row.values.map((value, index) => { return <td key={index} className="table-td-xs">{value}</td> })
                                    }
                                </tr>
                            })
                        }
                    </tbody>
                </Table>
        }




        return (
            <Card>
                <Card.Header className='card-header-light'>
                    {mobileIcon}&nbsp;&nbsp;{translations[this.props.language].contact_us}
                </Card.Header>
                <Card.Body style={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 0 }}>
                    <Table size='sm' style={{ marginLeft: 10 }}>
                        <tbody>
                            {
                                this.props.multiTenantList.map((tenant, index) => {
                                    return <tr key={index}>

                                        <td className="table-td-xs"><strong>{tenant.paragraphContentOne}</strong></td>
                                        <td className="table-td-xs">{tenant.emailAddress}</td>
                                        <td className="table-td-xs">{tenant.phone}</td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        )
    }
}

export default connect(mapStateToProps)(ContactTenants);